import { isCreditManagementDataLoading } from "./action";

const initialState = {
    creditManagementInputData: null,
    creditManagementDropDownData: null,
    creditManagementTableData: null,
    creditManagementUsageTableData: null,
    creditManagementMeterTableData: null,
    creditManagementAdjEntryTableData: null,
    isCreditManagementDataLoading: false,
};
const creditManagementReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_CREDIT_MANAGEMENT_INPUT_DATA':
            return { ...state, creditManagementInputData: action.payload };
        case 'SET_CREDIT_MANAGEMENT_DROP_DOWN_DATA':
            return { ...state, creditManagementDropDownData: action.payload };
        case 'SET_CREDIT_MANAGEMENT_TABLE_DATA':
            return { ...state, creditManagementTableData: action.payload };
        case 'SET_CREDIT_MANAGEMENT_USAGE_TABLE_DATA':
            return { ...state, creditManagementUsageTableData: action.payload };
        case 'SET_CREDIT_MANAGEMENT_METER_TABLE_DATA':
            return { ...state, creditManagementMeterTableData: action.payload };
        case 'SET_CREDIT_MANAGEMENT_ADJ_ENTRY_TABLE_DATA':
            return { ...state, creditManagementAdjEntryTableData: action.payload };
        case 'IS_CREDIT_MANAGEMENT_DATA_LOADING': 
            return { ...state, isCreditManagementDataLoading: action.payload };
        default:
            return state;
    }
};

export default creditManagementReducer;